import { Menu } from "@mui/material";
import React, { useEffect, useState } from "react";

interface IProps {
	data: any[];
	children: any;
	renderElement: (el: any, index: number) => any;
}

const ListModal = (props: IProps) => {
	const [data, setData] = useState<any[]>(props.data);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	useEffect(() => {
		setData(props.data);
	}, [props.data]);

	return (
		<div>
			<div
				className="cursor-pointer"
				onClick={(event) => {
					setAnchorEl(event.currentTarget);
				}}
			>
				{props.children}
			</div>
			<Menu
				open={anchorEl ? true : false}
				anchorEl={anchorEl}
				onClose={() => {
					setAnchorEl(null);
				}}
				variant={"menu"}
				className="overflow-visible"
				sx={{ overflowX: "unset", overflowY: "unset" }}
			>
				<div className="flex flex-col gap-3 px-3 py-4">
					{data.map((d, i) => props.renderElement(d, i))}
				</div>
			</Menu>
		</div>
	);
};

export default ListModal;
